import { jsxs, jsx } from "react/jsx-runtime";
import { useState, useRef } from "react";
import { Dialog, Button } from "@graphiql/react";
import { collectionsStore } from "../store.js";
const ImportDialog = ({
  open,
  onClose,
  onImport,
  allowReplace = true
}) => {
  const [importMode, setImportMode] = useState("merge");
  const [importError, setImportError] = useState(null);
  const [pastedText, setPastedText] = useState("");
  const fileInputRef = useRef(null);
  const validateAndImport = (text) => {
    try {
      JSON.parse(text);
    } catch {
      setImportError(
        "Invalid JSON. Please paste or select a valid collections export."
      );
      return;
    }
    const analysis = collectionsStore.getState().actions.analyzeImport(text);
    if (!analysis.ok) {
      setImportError("This isn’t a valid collections export.");
      return;
    }
    onImport(text, allowReplace ? importMode : "merge");
    onClose();
  };
  const handleImport = () => {
    var _a, _b;
    const pasted = pastedText.trim();
    if (pasted) {
      validateAndImport(pasted);
      return;
    }
    const file = (_b = (_a = fileInputRef.current) == null ? void 0 : _a.files) == null ? void 0 : _b[0];
    if (!file) {
      setImportError("Paste a collections export or choose a file.");
      return;
    }
    const reader = new FileReader();
    reader.onload = (e) => {
      var _a2;
      validateAndImport((_a2 = e.target) == null ? void 0 : _a2.result);
    };
    reader.readAsText(file);
  };
  return /* @__PURE__ */ jsxs(Dialog, { open, onOpenChange: (o) => !o && onClose(), children: [
    /* @__PURE__ */ jsx(Dialog.Header, { children: "Import collections" }),
    /* @__PURE__ */ jsx(Dialog.Body, { children: /* @__PURE__ */ jsxs("div", { className: "graphiql-import-export-section", children: [
      /* @__PURE__ */ jsx(
        "textarea",
        {
          className: "graphiql-import-export-textarea",
          rows: 6,
          "aria-label": "Paste collections export JSON",
          placeholder: "Paste a collections export (JSON)…",
          value: pastedText,
          onChange: (e) => {
            setPastedText(e.target.value);
            setImportError(null);
          }
        }
      ),
      /* @__PURE__ */ jsx(
        "input",
        {
          ref: fileInputRef,
          type: "file",
          accept: ".json,application/json",
          onChange: () => setImportError(null)
        }
      ),
      /* @__PURE__ */ jsxs("fieldset", { className: "graphiql-import-export-mode", children: [
        /* @__PURE__ */ jsx("legend", { children: "Import mode" }),
        /* @__PURE__ */ jsxs("label", { children: [
          /* @__PURE__ */ jsx(
            "input",
            {
              type: "radio",
              name: "import-mode",
              value: "merge",
              checked: !allowReplace || importMode === "merge",
              onChange: () => setImportMode("merge")
            }
          ),
          "Merge (add new, update changed in place)"
        ] }),
        allowReplace && /* @__PURE__ */ jsxs("label", { children: [
          /* @__PURE__ */ jsx(
            "input",
            {
              type: "radio",
              name: "import-mode",
              value: "replace",
              checked: importMode === "replace",
              onChange: () => setImportMode("replace")
            }
          ),
          "Replace (remove all existing collections)"
        ] })
      ] }),
      importError && /* @__PURE__ */ jsx("p", { className: "graphiql-import-export-error", children: importError }),
      /* @__PURE__ */ jsx(Button, { type: "button", variant: "primary", onClick: handleImport, children: "Import" })
    ] }) })
  ] });
};
export {
  ImportDialog
};
//# sourceMappingURL=import-dialog.js.map
